// projects/humanresources-personnel/src/assets/i18n/*/hr-per-borrowing.json
export class HrPerBorrowingKey {
    private static readonly keyPrefix = 'hrPerBorrowing';
    public static title = `${HrPerBorrowingKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerBorrowingKey.keyPrefix}.pageHeader`;
    public static degree = `${HrPerBorrowingKey.keyPrefix}.degree`;
    public static indicator = `${HrPerBorrowingKey.keyPrefix}.indicator`;
    public static additionalIndicator = `${HrPerBorrowingKey.keyPrefix}.additionalIndicator`;
    public static numberOfDay = `${HrPerBorrowingKey.keyPrefix}.numberOfDay`;
    public static lawCode = `${HrPerBorrowingKey.keyPrefix}.lawCode`;
    public static kindOfDeptId = `${HrPerBorrowingKey.keyPrefix}.kindOfDeptId`;
    public static amountOfDept = `${HrPerBorrowingKey.keyPrefix}.amountOfDept`;
    public static amountOfDeptPaid = `${HrPerBorrowingKey.keyPrefix}.amountOfDeptPaid`;
    public static dutyLocation = `${HrPerBorrowingKey.keyPrefix}.dutyLocation`;
    public static date = `${HrPerBorrowingKey.keyPrefix}.date`;
    public static deptPaymentDate = `${HrPerBorrowingKey.keyPrefix}.deptPaymentDate`;
}
